import React from 'react';

const DirectorMessagePage = () => {
  return (
    <div className="bg-white">
      {/* Hero Banner */}
      <div className="relative bg-slate py-20">
        <div className="absolute inset-0 bg-gradient-to-r from-slate to-crimson opacity-90"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">Director's Message</h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">Academic leadership for transformative education and research</p>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 md:px-8">
          {/* Main Content Card */}
          <div className="bg-white rounded-xl shadow-soft p-12 md:p-16">
            <div className="grid md:grid-cols-4 gap-12 mb-8">
              {/* Photo Placeholder */}
              <div className="md:col-span-1">
                <div className="bg-gray-100 rounded-lg aspect-[3/4] flex items-center justify-center">
                  <i className="fas fa-user-graduate text-8xl text-gray-400"></i>
                </div>
                <div className="mt-6 text-center">
                  <h3 className="font-bold text-xl text-slate">Dr. Anita Desai</h3>
                  <p className="text-base text-gray-500 mt-2">Director</p>
                  <p className="text-sm text-gray-400 mt-1">FiT Engineering College</p>
                </div>
              </div>
            
            {/* Message Content */}
            <div className="md:col-span-3 space-y-6">
              <p className="text-gray-600 leading-relaxed text-lg">
                Dear Students and Colleagues,
              </p>
              <p className="text-gray-600 leading-relaxed">
                As Director of FiT Engineering College, I am honored to lead our academic mission and witness the transformative journey of each student who walks through our doors. Education at FIT is not just about imparting knowledge; it's about igniting curiosity and building character.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our academic programs are designed to be rigorous yet flexible, allowing students to explore their interests while building a strong foundation in their chosen fields. We emphasize experiential learning, critical thinking, and problem-solving skills that are essential in today's rapidly evolving technological landscape.
              </p>
              <p className="text-gray-600 leading-relaxed">
                The success of our institution lies in our distinguished faculty who bring together academic excellence and industry experience. They mentor, guide, and inspire our students to achieve their full potential. Our research initiatives and industry collaborations provide platforms for innovation and real-world application of knowledge.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We have cultivated a learning environment that encourages interdisciplinary collaboration, creative thinking, and ethical practice. Our modern classrooms, advanced laboratories, and digital resources ensure that our students have access to the best educational tools and technologies.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Beyond academics, we focus on the overall development of our students. Our vibrant campus life, with numerous clubs, societies, and cultural activities, provides opportunities for students to discover their passions, develop leadership skills, and form lifelong friendships.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We are committed to creating an inclusive, supportive environment where diversity is celebrated and every student feels valued. Our goal is to develop not just competent engineers and technologists, but responsible global citizens who will lead with integrity and compassion.
              </p>
              <p className="text-gray-600 leading-relaxed">
                As we prepare our students for the challenges of the 21st century, we remain committed to our core mission of excellence in education, research, and service to society. The success stories of our alumni, who are making significant contributions in various fields across the globe, inspire us to continually raise our standards.
              </p>
              <p className="text-gray-600 leading-relaxed">
                I invite you to make the most of the opportunities at FIT and join us in our pursuit of excellence.
              </p>
              <p className="text-gray-600 leading-relaxed font-semibold mt-8">
                With warm regards,<br/>
                <span className="text-crimson text-xl">Dr. Anita Desai</span><br/>
                <span className="text-base font-normal">Director, FiT Engineering College</span>
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DirectorMessagePage;